(() => {
  if (customElements.get('magic-file-upload')) return;
  customElements.define('magic-file-upload', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.entries = []; this.session = crypto.randomUUID(); this.running = false; this.saving = false; this.saved = false;
      this.max = Number(this.dataset.maxMb || 50) * 1024 * 1024;
      this.properties = new Map();
      this.scope = this.closest('section') || this.closest('product-info') || this.parentElement;
      this.input = this.querySelector('[data-files]'); this.list = this.querySelector('[data-list]');
      this.status = this.querySelector('[data-status]'); this.saveButton = this.querySelector('[data-save]'); this.notes = this.querySelector('[data-notes]');
      this.input.addEventListener('change', () => { this.add(this.input.files); this.input.value = ''; });
      const drop = this.querySelector('.mmfu-drop');
      if (drop.matches('button')) drop.addEventListener('click', () => this.input.click());
      drop.addEventListener('dragover', e => e.preventDefault());
      drop.addEventListener('drop', e => { e.preventDefault(); this.add(e.dataTransfer.files); });
      this.notes.addEventListener('input', () => this.invalidate());
      this.saveButton.addEventListener('click', () => this.save());
      this.guard = e => {
        this.bindForm();
        if (e.target !== this.form) return;
        if (!this.saved) { e.preventDefault(); e.stopImmediatePropagation(); this.status.textContent = this.messages.need_files; this.scrollIntoView({block:'center', behavior:'smooth'}); }
        else this.syncProperties();
      };
      this.onFormData = e => {
        this.bindForm();
        if (e.target !== this.form) return;
        for (const [name, value] of this.properties) {
          if (value) e.formData.set(`properties[${name}]`, value);
          else e.formData.delete(`properties[${name}]`);
        }
      };
      document.addEventListener('submit', this.guard, true);
      document.addEventListener('formdata', this.onFormData, true);
      this.bindForm();
      this.formObserver = new MutationObserver(() => { if (this.bindForm()) this.render(); });
      this.formObserver.observe(this.scope, {childList:true, subtree:true});
      this.config = fetch(this.dataset.url, {headers:{Accept:'application/json'}}).then(async r => {
        if (!r.ok) throw new Error(); const config = await r.json();
        this.max = Math.min(this.max, config.maxBytes); return true;
      });
      this.config.catch(() => { this.status.textContent = this.messages.error; });
      this.render();
    }
    disconnectedCallback() {
      document.removeEventListener('submit', this.guard, true);
      document.removeEventListener('formdata', this.onFormData, true);
      this.formObserver?.disconnect();
      this.clearProperties();
      if (this.payment) this.payment.hidden = this.paymentHidden;
      for (const entry of this.entries || []) entry.xhr?.abort();
      this.started = false;
    }
    purchaseForm(form) {
      return form?.matches('form[action*="/cart/add"]') && !(form.getAttribute('id') || '').includes('installment') &&
        [...form.elements].some(el => (el.type === 'submit' || el.name === 'add') && el.form === form);
    }
    bindForm() {
      const explicit = this.dataset.formId && document.getElementById(this.dataset.formId);
      const nearest = this.closest('form[action*="/cart/add"]');
      const form = [explicit, nearest, ...this.scope.querySelectorAll('form[action*="/cart/add"]')].find(candidate => this.purchaseForm(candidate));
      if (form === this.form) return false;
      this.clearProperties();
      if (this.payment) this.payment.hidden = this.paymentHidden;
      this.form = form;
      this.payment = form?.querySelector('.shopify-payment-button');
      if (this.payment) { this.paymentHidden = this.payment.hidden; this.payment.hidden = true; }
      this.syncProperties();
      return true;
    }
    clearProperties() {
      for (const el of this.form?.querySelectorAll('[data-magic-upload-property]') || []) el.remove();
    }
    syncProperties() {
      if (!this.form) return;
      for (const [name, value] of this.properties) {
        let el = [...this.form.elements].find(input => input.name === `properties[${name}]`);
        if (!value) { if (el?.hasAttribute('data-magic-upload-property')) el.remove(); continue; }
        if (!el) {
          el = document.createElement('input'); el.type = 'hidden'; el.name = `properties[${name}]`;
          el.setAttribute('data-magic-upload-property',''); this.form.append(el);
        }
        el.value = value;
      }
    }
    property(name, value) {
      this.properties.set(name, value);
      this.syncProperties();
    }
    invalidate() {
      this.saved = false;
      for (const name of this.properties.keys()) this.property(name, '');
      this.render();
    }
    add(files) {
      if (this.saving) return;
      for (const file of files) this.entries.push({file, state:'queued', progress:0, receipt:null});
      this.invalidate(); this.pump();
    }
    endpoint(op, name) {
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('session', this.session); url.searchParams.set('product', this.dataset.productId); url.searchParams.set('op', op);
      if (name) url.searchParams.set('name', name);
      return url;
    }
    async pump() {
      if (this.running) return; this.running = true;
      try {
        await this.config;
        for (;;) {
          const entry = this.entries.find(e => e.state === 'queued'); if (!entry) break;
          if (!entry.file.size || entry.file.size > this.max) { entry.state = 'failed'; entry.error = this.messages[entry.file.size ? 'size_error' : 'empty']; this.render(); continue; }
          entry.state = 'uploading'; this.render();
          try { entry.receipt = await this.upload(entry); entry.state = 'uploaded'; }
          catch { entry.state = 'failed'; entry.error = this.messages.failed; }
          this.render();
        }
      } catch { for (const entry of this.entries) if (entry.state === 'queued') { entry.state = 'failed'; entry.error = this.messages.error; } }
      finally { this.running = false; this.render(); }
    }
    upload(entry) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest(); entry.xhr = xhr;
        xhr.open('POST', this.endpoint('upload', entry.file.name)); xhr.setRequestHeader('Content-Type','application/octet-stream'); xhr.timeout = 300000;
        xhr.upload.onprogress = e => { if (e.lengthComputable) { entry.progress = Math.round(e.loaded/e.total*100); entry.bar.value = entry.progress; } };
        xhr.onload = () => { try { const data = JSON.parse(xhr.responseText); if (xhr.status < 200 || xhr.status >= 300 || !data.receipt) throw new Error(); resolve(data.receipt); } catch { reject(new Error()); } };
        xhr.onerror = xhr.ontimeout = xhr.onabort = () => reject(new Error()); xhr.send(entry.file);
      });
    }
    render() {
      const details = this.querySelector('[data-upload-details]');
      const trigger = this.querySelector('[data-upload-trigger]');
      if (details) details.hidden = !this.entries.length;
      if (trigger) trigger.disabled = this.saving;
      this.list.replaceChildren();
      for (const entry of this.entries) {
        const row = document.createElement('li'); const text = document.createElement('span');
        text.textContent = `${entry.file.name} (${(entry.file.size/1048576).toFixed(2)} MB) — ${entry.error || this.messages[entry.state]}`; row.append(text);
        if (entry.state === 'uploading') { const bar = document.createElement('progress'); bar.max = 100; bar.value = entry.progress; bar.setAttribute('aria-label', entry.file.name); entry.bar = bar; row.append(bar); }
        if (entry.state === 'failed') { const retry = document.createElement('button'); retry.type = 'button'; retry.textContent = this.messages.retry; retry.disabled = this.saving; retry.onclick = () => { entry.state = 'queued'; entry.error = ''; this.config = fetch(this.dataset.url).then(async r => { if (!r.ok) throw new Error(); this.max = Math.min(this.max,(await r.json()).maxBytes); }); this.pump(); }; row.append(retry); }
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = this.messages.remove; remove.disabled = this.saving;
        remove.onclick = () => { entry.xhr?.abort(); this.entries = this.entries.filter(e => e !== entry); this.invalidate(); }; row.append(remove); this.list.append(row);
      }
      const ready = this.entries.length > 0 && this.entries.every(e => e.state === 'uploaded');
      this.saveButton.disabled = !ready || this.saving || this.saved || !this.form;
      this.saveButton.textContent = this.messages[this.saving ? 'saving':'save'];
      this.input.disabled = this.saving; this.notes.disabled = this.saving;
      if (!this.saving) this.status.textContent = this.messages[this.saved ? 'saved' : ready ? 'ready' : this.entries.length ? 'wait':'need_files'];
      if (!this.entries.length && !this.saving) this.status.textContent = '';
    }
    async save() {
      if (this.saving || !this.entries.length || this.entries.some(e => e.state !== 'uploaded')) return;
      this.bindForm();
      if (!this.form) { this.status.textContent = this.messages.error; return; }
      this.saving = true; this.render();
      try {
        const response = await fetch(this.endpoint('save'), {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({receipts:this.entries.map(e => e.receipt), notes:this.notes.value})});
        const data = await response.json();
        if (!response.ok || !data.manifestUrl || new URL(data.manifestUrl).protocol !== 'https:' || data.session !== this.session || data.count !== this.entries.length) throw new Error();
        this.bindForm();
        if (!this.form) throw new Error();
        this.property('Uploaded files',data.manifestUrl); this.property('File count',String(data.count)); this.property('Upload reference',data.session); this.property('_Upload reference',data.session);
        this.saved = true;
      } catch { this.status.textContent = this.messages.error; }
      finally { this.saving = false; const failed = !this.saved; this.render(); if (failed) this.status.textContent = this.messages.error; }
    }
  });
})();
